var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.5L6.8 9.10593V13.3148L9.2 14.5V9.10593L14 3.5H2Z",
    stroke: "#E2E3E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchFilter);
export default __webpack_public_path__ + "static/media/icon-searchFilter.923b88716519c8a1de4333cce59e5435.svg";
export { ForwardRef as ReactComponent };